module.exports = __webpack_public_path__ + "static/media/close.74ae87e3.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/CarEditorPage/components/changeCarData/img/close.png
// module id = 1708
// module chunks = 0